import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isTokenExpired: false,
  },
  reducers: {
    setTokenExpired(state, action) {
      state.isTokenExpired = action.payload;
    },
  },
});

export const getTokenExpired = (state) => state.authSlice.isTokenExpired;
export const { setTokenExpired } = authSlice.actions;
export default authSlice.reducer;